var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38139 13.3492C4.60299 13.3492 0.510498 9.86131 0.510498 6.21383C0.510498 3.35834 2.69092 1.04297 5.38139 1.04297C8.07187 1.04297 10.2529 3.35834 10.2529 6.21383C10.2529 9.86131 6.1598 13.3492 5.38139 13.3492Z",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00553 6.17085C7.00553 5.2265 6.27859 4.4613 5.38212 4.4613C4.48499 4.4613 3.75806 5.2265 3.75806 6.17085C3.75806 7.1145 4.48499 7.8797 5.38212 7.8797C6.27859 7.8797 7.00553 7.1145 7.00553 6.17085Z",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38139 13.3492C4.60299 13.3492 0.510498 9.86131 0.510498 6.21383C0.510498 3.35834 2.69092 1.04297 5.38139 1.04297C8.07187 1.04297 10.2529 3.35834 10.2529 6.21383C10.2529 9.86131 6.1598 13.3492 5.38139 13.3492Z",
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAd);
export default __webpack_public_path__ + "static/media/locationAd.c8b6339c71fd27151bf76b7987485bfe.svg";
export { ForwardRef as ReactComponent };